/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M7.00003 10.0002L10.0001 13.0003L6.99997 16.0004M13 16.0002H17"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<rect
				x="2"
				y="2"
				width="20"
				height="20"
				rx="6"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<rect
				opacity="0.12"
				x="2"
				y="2"
				width="20"
				height="20"
				rx="6"
				fill="currentColor"
			/>
			<path
				d="M7.00006 10L10.0001 13.0001L7 16.0001M13.0001 16H17.0001M11.6 22H12.4C15.7603 22 17.4405 22 18.7239 21.346C19.8529 20.7708 20.7708 19.8529 21.346 18.7239C22 17.4405 22 15.7603 22 12.4V11.6C22 8.23969 22 6.55953 21.346 5.27606C20.7708 4.14708 19.8529 3.2292 18.7239 2.65396C17.4405 2 15.7603 2 12.4 2H11.6C8.23969 2 6.55953 2 5.27606 2.65396C4.14708 3.2292 3.2292 4.14708 2.65396 5.27606C2 6.55953 2 8.23969 2 11.6V12.4C2 15.7603 2 17.4405 2.65396 18.7239C3.2292 19.8529 4.14708 20.7708 5.27606 21.346C6.55953 22 8.23969 22 11.6 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M4.52606 1.90396C5.80953 1.25 7.48968 1.25 10.85 1.25L13.15 1.25C16.5103 1.25 18.1905 1.25 19.4739 1.90396C20.6029 2.4792 21.5208 3.39709 22.096 4.52606C22.75 5.80953 22.75 7.48968 22.75 10.85L22.75 10.85L22.75 13.15C22.75 16.5103 22.75 18.1905 22.096 19.4739C21.5208 20.6029 20.6029 21.5208 19.4739 22.096C18.1905 22.75 16.5103 22.75 13.15 22.75L10.85 22.75C7.48968 22.75 5.80953 22.75 4.52605 22.096C3.39708 21.5208 2.4792 20.6029 1.90396 19.4739C1.25 18.1905 1.25 16.5103 1.25 13.15L1.25 10.85C1.25 7.48969 1.25 5.80953 1.90396 4.52606C2.4792 3.39709 3.39708 2.4792 4.52606 1.90396ZM7.53041 9.46991C7.23752 9.17702 6.76264 9.17702 6.46975 9.46991C6.17686 9.7628 6.17686 10.2377 6.46975 10.5306L8.93947 13.0003L6.46969 15.47C6.1768 15.7629 6.17679 16.2378 6.46968 16.5307C6.76257 16.8236 7.23745 16.8236 7.53034 16.5307L10.5305 13.5306C10.6711 13.39 10.7501 13.1992 10.7501 13.0003C10.7501 12.8014 10.6711 12.6106 10.5305 12.47L7.53041 9.46991ZM13.0001 15.2502C12.5859 15.2502 12.2501 15.586 12.2501 16.0002C12.2501 16.4145 12.5859 16.7502 13.0001 16.7502L17.0001 16.7502C17.4143 16.7502 17.7501 16.4145 17.7501 16.0002C17.7501 15.586 17.4143 15.2502 17.0001 15.2502L13.0001 15.2502Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M22 9.5V9V9C22 8.07116 22 7.60674 21.9487 7.21684C21.5942 4.52444 19.4756 2.40579 16.7832 2.05133C16.3933 2 15.9288 2 15 2H11.6C8.23969 2 6.55953 2 5.27606 2.65396C4.14708 3.2292 3.2292 4.14708 2.65396 5.27606C2 6.55953 2 8.23969 2 11.6V12.4C2 15.7603 2 17.4405 2.65396 18.7239C3.2292 19.8529 4.14708 20.7708 5.27606 21.346C6.55953 22 8.23969 22 11.6 22H15C15.9288 22 16.3933 22 16.7832 21.9487C19.4756 21.5942 21.5942 19.4756 21.9487 16.7832C22 16.3933 22 15.9288 22 15V15V14.5M7 10L10.0001 13.0001L6.99994 16.0001M13 16H17"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M7.00006 10L10.0001 13.0001L7 16.0001M13.0001 16H17.0001M11.6 22H12.4C15.7603 22 17.4405 22 18.7239 21.346C19.8529 20.7708 20.7708 19.8529 21.346 18.7239C22 17.4405 22 15.7603 22 12.4V11.6C22 8.23969 22 6.55953 21.346 5.27606C20.7708 4.14708 19.8529 3.2292 18.7239 2.65396C17.4405 2 15.7603 2 12.4 2H11.6C8.23969 2 6.55953 2 5.27606 2.65396C4.14708 3.2292 3.2292 4.14708 2.65396 5.27606C2 6.55953 2 8.23969 2 11.6V12.4C2 15.7603 2 17.4405 2.65396 18.7239C3.2292 19.8529 4.14708 20.7708 5.27606 21.346C6.55953 22 8.23969 22 11.6 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M10.85 1.25C7.48969 1.25 5.80953 1.25 4.52606 1.90396C3.39709 2.4792 2.4792 3.39708 1.90396 4.52606C1.25 5.80953 1.25 7.48969 1.25 10.85L1.25 13.15C1.25 16.5103 1.25 18.1905 1.90396 19.4739C2.4792 20.6029 3.39708 21.5208 4.52606 22.096C5.80953 22.75 7.48969 22.75 10.85 22.75H13.15C16.5103 22.75 18.1905 22.75 19.4739 22.096C20.6029 21.5208 21.5208 20.6029 22.096 19.4739C22.75 18.1905 22.75 16.5103 22.75 13.15V10.85C22.75 7.48969 22.75 5.80953 22.096 4.52606C21.5208 3.39709 20.6029 2.4792 19.4739 1.90396C18.1905 1.25 16.5103 1.25 13.15 1.25L10.85 1.25Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M6.46976 9.46991C6.76265 9.17702 7.23753 9.17702 7.53042 9.46991L10.5305 12.47C10.6711 12.6106 10.7502 12.8014 10.7502 13.0003C10.7502 13.1992 10.6711 13.39 10.5305 13.5306L7.53035 16.5307C7.23746 16.8236 6.76258 16.8236 6.46969 16.5307C6.1768 16.2378 6.17681 15.7629 6.4697 15.47L8.93949 13.0003L6.46976 10.5306C6.17687 10.2377 6.17687 9.76281 6.46976 9.46991ZM12.2501 16.0002C12.2501 15.586 12.5859 15.2502 13.0001 15.2502L17.0001 15.2502C17.4143 15.2502 17.7501 15.586 17.7501 16.0002C17.7501 16.4145 17.4143 16.7502 17.0001 16.7502L13.0001 16.7502C12.5859 16.7502 12.2501 16.4145 12.2501 16.0002Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
